import React, { useId, useMemo } from 'react';
import Icon from '@ant-design/icons';
import { IconComponentProps } from '@ant-design/icons/lib/components/Icon';

export interface AIStarsIconProps extends IconComponentProps {
  gradientStart?: string;
  gradientEnd?: string;
}

export const AIStarsIcon = ({ gradientStart, gradientEnd, ...props }: AIStarsIconProps) => {
  const gradientId = `starsGradient${useId().replace(/:/g, '')}`;

  const startColor = gradientStart ?? 'var(--bc-ai-gradient-start, #1D4A9B)';
  const endColor = gradientEnd ?? 'var(--bc-ai-gradient-end, #55C2EF)';

  const AIStarsSvg = useMemo(() => {
    const Svg = () => (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="1em" height="1em">
        <path fill={`url(#${gradientId})`}
              d="m18 3 1.5-3L21 3l3 1.5L21 6l-1.5 3L18 6l-3-1.5L18 3ZM6 9l3-6 3 6 6 3-6 3-3 6-3-6-6-3 6-3Zm13.5 6 1.5 3 3 1.5-3 1.5-1.5 3-1.5-3-3-1.5 3-1.5 1.5-3Z"/>
        <defs>
          <linearGradient id={gradientId} x1="3" x2="24" y1="15" y2="6" gradientUnits="userSpaceOnUse">
            <stop offset=".13" stopColor={startColor}/>
            <stop offset="1" stopColor={endColor}/>
          </linearGradient>
        </defs>
      </svg>
    );
    return Svg;
  }, [gradientId, startColor, endColor]);

  return <Icon component={AIStarsSvg} {...props} />;
};
